import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconDefinition} from "@fortawesome/fontawesome-common-types";
import {faCheck} from "@fortawesome/pro-solid-svg-icons/faCheck";
import {faCircleNotch} from "@fortawesome/pro-solid-svg-icons/faCircleNotch";

export interface IconWithLoadingProps {
  icon?: IconDefinition;
  className?: string;
  isLoading?: boolean;
}

export default function IconWithLoading({icon = faCheck, className = 'me-1', isLoading = false}: IconWithLoadingProps) {

  return (
    <FontAwesomeIcon icon={isLoading ? faCircleNotch : icon} className={className} spin={isLoading}/>
  );
}
